import { authClient, API } from "../../utils/index";

export const getPromoClientSectorsAdmin = () => {
	return authClient().get(`${API}/promo-client-sector?all=1`);
};

export const getPromoClientSectorById = (id) => {
	return authClient().get(`${API}/promo-client-sector/${id}`);
};

export const postPromoClientSector = (body) => {
	return authClient().post(`${API}/promo-client-sector`, body);
};

export const putPromoClientSector = (id, body) => {
	return authClient().put(`${API}/promo-client-sector/${id}`, body);
};

export const movePromoClientSector = (id, direction) => {
	return authClient().post(`${API}/promo-client-sector/${id}/move`, { direction });
};

export const deletePromoClientSector = (id) => {
	return authClient().delete(`${API}/promo-client-sector/${id}`);
};
